import { FullMarketExitService } from './FullMarketExitService'
import { PromoPlayPhase, PromoPlayPhaseInfo, PromoPlayService } from './PromoPlayService'

export class BlockMarketFeature {
	protected fullMarketExitService = new FullMarketExitService()
	protected promoPlayService = new PromoPlayService()

	isEnabled(residentialState: string, geoLocationState: string): boolean {
		const isFullMarketExitActive = this.fullMarketExitService.isRegistrationBlocked(residentialState, geoLocationState)
		const isPromoPlayActive = this.promoPlayService.isAnyPhaseActive(residentialState, geoLocationState)

		return isFullMarketExitActive || isPromoPlayActive
	}

	isGameplayBlockEnabled(residentialState: string, geoLocationState: string): boolean {
		const isBlockedByFullMarketExit = this.fullMarketExitService.isGameplayBlocked(residentialState, geoLocationState)
		const isPromoPlayPhase2OnwardsActive = this.promoPlayService.isPhase2OrLaterActive(
			residentialState,
			geoLocationState,
		)

		return isBlockedByFullMarketExit || isPromoPlayPhase2OnwardsActive
	}

	isPromoPlayOnlyMarketsEnabled(): boolean {
		return this.promoPlayService.isEnabled()
	}

	isPromoPlayOnlyMarket(residentialState: string, geoLocationState: string): boolean {
		return this.promoPlayService.isPromoOnlyMarket(residentialState, geoLocationState)
	}

	getPromoPlayPhase1Info(residentialState: string, geoLocationState: string): PromoPlayPhaseInfo {
		return this.promoPlayService.getPhaseInfo(PromoPlayPhase.Phase1, residentialState, geoLocationState)
	}

	getPromoPlayPhase2Info(residentialState: string, geoLocationState: string): PromoPlayPhaseInfo {
		return this.promoPlayService.getPhaseInfo(PromoPlayPhase.Phase2, residentialState, geoLocationState)
	}

	getPromoPlayPhase3Info(residentialState: string, geoLocationState: string): PromoPlayPhaseInfo {
		return this.promoPlayService.getPhaseInfo(PromoPlayPhase.Phase3, residentialState, geoLocationState)
	}

	isWithin60DaysPromoPlayPhase3(residentialState: string, geoLocationState: string): boolean {
		return this.promoPlayService.isWithin60DaysOfPhase3(residentialState, geoLocationState)
	}

	getMarketsBlockedAtRegistration(): string[] {
		return this.fullMarketExitService.getBlockedAtRegistration()
	}

	getMarketsBlockedAtLogin(): string[] {
		return this.fullMarketExitService.getBlockedAtLogin()
	}

	isDelawareMarketExitModalEnabled(): boolean {
		return this.fullMarketExitService.isDelawareExitModalEnabled()
	}

	isFullMarketExitModalsEnabled() {
		return this.fullMarketExitService.isFullMarketExitModalsEnabled()
	}
}
